import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import no from "./no.png"
import yes from "./yes.png"

const 矩形形状 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { fpcRectangularShape: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} helpURL={HELP_LINKS.矩形形状} legend="矩形形状">
      <RadioGroup name={FIELD_NAMES.矩形形状} selectedValue={values.fpcRectangularShape} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.矩形形状.はい.value} prefixImageSrc={yes}>
            はい
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.矩形形状.いいえ.value} prefixImageSrc={no}>
            いいえ
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.fpcRectangularShape} />
    </OneClickField>
  )
}

export default 矩形形状
